import EquipmentMobile from "./EquipmentMobile";

export default EquipmentMobile;
export { EquipmentMobile };
